import React from "react";
import { styled, Tooltip, tooltipClasses } from "@mui/material";

const Container = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#E789FF",
    fontSize: theme.typography.bodyL.fontSize,
    fontWeight: 600,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1, 1.5),
  },
}));

const ComingSoonWrapper = ({
  children,
  title = "Coming soon! 🚀",
  includeSpan = true,
  isMaxWidth = true,
  sx = {},
}) => {
  // Ensure we only try to clone if children is a valid React element
  const childWithDisabled = React.isValidElement(children)
    ? React.cloneElement(children, { disabled: true })
    : children;

  return (
    <Container title={title}>
      {includeSpan
        ? <span style={{
            display: "inline-flex",
            ...(isMaxWidth && { width: "100%" }),
            ...sx,
          }}>
            {childWithDisabled}
          </span>
        : childWithDisabled}
    </Container>
  );
};

export default ComingSoonWrapper;
